import { trackAction } from 'app/shared/utils/tracking';

export const tracking = {
  openModal: () => {
    trackAction('mobile_slide_in_crm_form_opened', {
      category: 'mobile_slide_in',
      description: 'user opens form in mobile slide-in',
      label: 'mobile_slide_in',
    });
  },
  dismissed: () => {
    trackAction('mobile_slide_in_crm_dismissed', {
      category: 'mobile_slide_in',
      description: 'user dismisses mobile slide-in',
      label: 'mobile_slide_in',
    });
  },
  init: () => {
    trackAction('mobile_slide_in_crm_form_submit_initialized', {
      category: 'mobile_slide_in',
      description: 'user submits form in mobile slide-in',
      label: 'mobile_slide_in',
    });
  },
  success: () => {
    trackAction('mobile_slide_in_crm_form_submit_success', {
      category: 'mobile_slide_in',
      description: 'user successfully submits form in mobile slide-in',
      label: 'mobile_slide_in',
    });
  },
  failure: () => {
    trackAction('mobile_slide_in_crm_form_submit_failure', {
      category: 'mobile_slide_in',
      description: 'user fails to submit form in mobile slide-in',
      label: 'mobile_slide_in',
    });
  },
  changedToVisible: () => {
    trackAction('mobile_slide_in_crm_displayed', {
      category: 'mobile_slide_in',
      description: 'user views mobile slide-in',
      label: 'mobile_slide_in',
    });
  },
};
